import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PromoStoryRing from "./PromoStoryRing";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../components/firebase";
import { useNavigate } from "react-router-dom";
import PromoQuestDialog from "./PromoQuestDialog";
import xLogoPromo from "../../assets/images/x-logopromo.png";
import tgPromo from "../../assets/images/tgpromo.png";
import { smartOpen, buildTelegramOpen  } from "../utils/deeplinks";


// Glass Black
const GLASS = {
  bg: "linear-gradient(135deg, rgba(18,22,28,.88) 0%, rgba(10,13,17,.88) 100%)",
  border: "1px solid rgba(255,255,255,.08)",
  shadow: "0 10px 32px rgba(2,8,23,.45)",
  text: "#e5e7eb",
  subtext: "#9ca3af",
};


const lsKey = (uid, qid) => `quest:${uid}:${qid}:startedAt`;

const PromoTickets = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  const now = Date.now();
  const d = (n) => new Date(now + n * 24 * 60 * 60 * 1000).toISOString();

  const base = [
  // 1) X Follow
  {
    id: 1,
    title: "Follow @promospay",
    avatar: xLogoPromo,
    avatarScale: 1.85,
    amount: 15,
    token: "CrM",
    category: "VoteWithWallet",
    startAt: d(-1),
    due: d(14),
    boosted: true,
    quests: [
      {
        id: "x_follow_promospay",
        type: "x_follow",
        title: "Subscribe to @promospay",
        instructions:
          "Click Start → an X will open. Subscribe, come back and click Check. +15 CrM",
        image: xLogoPromo,
        rewardCrm: 15,
        x: {
          targetHandle: "promospay",
          
          profileUrl: "https://x.com/promospay",
        },
      },
    ],
  },

  // 2) X Retweet
  {
    id: 2,
    title: "Retweet our post",
    avatar: xLogoPromo,
    avatarScale: 1.85,
    amount: 15,
    token: "CrM",
    category: "VoteWithWallet",
    startAt: d(-1),
    due: d(14),
    boosted: false,
    quests: [
      {
        id: "x_retweet_announcement",
        type: "x_retweet",
        title: "Retweet our announcement",
        instructions:
          "Start → tweet. Retweet. Go back and click Check. +15 CrM",
        image: xLogoPromo,
        rewardCrm: 15,
        x: {
          tweetId: "1971199554675474711",
          tweetUrl: "https://x.com/promospay/status/1971199554675474711",
        },
      },
    ],
  },

  // 3) X Post with 
  {
    id: 3,
    title: "Tweet about us",
    avatar: xLogoPromo,
    avatarScale: 1.85,
    amount: 15,
    token: "CrM",
    category: "VoteWithWallet",
    startAt: d(-1),
    due: d(14),
    boosted: false,
    quests: [
      {
        id: "x_post_code",
        type: "x_post_code",
        title: "Tweet the code and @promospay",
        instructions:
          "Click Start → you'll get the code and template. Publish the tweet, paste the link below and click Check. +25 CrM",
        image: xLogoPromo,
        rewardCrm: 15,
        hashtag: "#PromosPay",
        proof: {
          requiresUrl: true,
          urlPlaceholder: "https://x.com/<your_handle>/status/<tweet_id>",
          urlPattern: /^(https?:\/\/)?(x\.com|twitter\.com)\/[^/]+\/status\/\d+\/?$/i,
        },
        x: {
          mentionHandle: "promospay",
          template:
            "Building with @promospay — on-chain promotions that actually work. #PromosPay",
        },
      },
    ],
  },

  // 4) Telegram Subscribe
{
  id: 4,
  title: "Join Telegram channel",
  avatar: tgPromo,
  avatarScale: 1.95,
  amount: 15,
  token: "CrM",
  category: "StakingChallenge",
  startAt: d(-1),
  due: d(14),
  boosted: true,
  quests: [
    {
      id: "tg_join_channel",
      type: "tg_join",
      title: "Subscribe to our Telegram",
      instructions:
        "Start → channel. Subscribe, come back, and click Check. +15 CrM",
      image: tgPromo,
      rewardCrm: 15,
      tg: {
        
        chatUsername: "PromosPayAI",
       
        webUrl: "https://t.me/PromosPayAI",
        deepLink: "tg://resolve?domain=PromosPayAI",
      },
    },
  ],
},


  // 5) Telegram Comment with code
  {
    id: 5,
    title: "Comment in Telegram",
    avatar: tgPromo,
    avatarScale: 1.95,
    amount: 15,
    token: "CrM",
    category: "StakingChallenge",
    startAt: d(-1),
    due: d(14),
    boosted: false,
    quests: [
      {
        id: "tg_comment_code",
        type: "tg_comment_code",
        title: "Leave a comment with the code",
        instructions:
          "Start → you'll receive a code. Leave a comment with this code under the post, then click Check. +15 CrM",
        image: tgPromo,
        rewardCrm: 15,
        tg: {
          chatId: "-1003056715632",
          messageId: 15,
          universalUrl: "https://t.me/c/3056715632/15",
          deepLink: "tg://openmessage?chat_id=-1003056715632&message_id=15",
        },
      },
    ],
  },
];


  const promoTickets = useMemo(
    () => base.map((t) => ({ ...t, id: String(t.id) })),
    
    []
  );

  //  «recently started» 
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setTick((v) => (v + 1) % 1_000_000), 1000);
    return () => clearInterval(i);
  }, []);

  const isRecentlyStarted = (t) => {
    if (!user?.uid) return false;
    try {
      const k = lsKey(user.uid, String(t.quests?.[0]?.id || t.id));
      const started = Number(localStorage.getItem(k) || "0");
      if (!started) return false;
      const elapsed = Date.now() - started; 
      return elapsed >= 0 && elapsed <= 90_000; 
    } catch {
      return false;
    }
  };

  // modal
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const handleOpen = (item) => {
    setSelected(item);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };
  

  // horizontal track
  const trackRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const drag = useRef({ startX: 0, scrollLeft: 0 });

  const onMouseDown = (e) => {
    const el = trackRef.current;
    if (!el) return;
    setDragging(true);
    drag.current.startX = e.pageX - el.offsetLeft;
    drag.current.scrollLeft = el.scrollLeft;
  };
  const onMouseMove = (e) => {
    const el = trackRef.current;
    if (!el || !dragging) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    el.scrollLeft = drag.current.scrollLeft - (x - drag.current.startX);
  };
  const stopDrag = () => setDragging(false);

  const scrollByCards = (dir = 1) => {
    const el = trackRef.current;
    if (!el) return;
    const first = el.querySelector("[data-card]");
    const cardW = first ? first.getBoundingClientRect().width : 100;
    el.scrollBy({ left: dir * cardW * 4, behavior: "smooth" });
  };

  return (
    <>
      {/* full-bleed container: from edge to edge in any layout*/}
      <Box
        sx={{
          mx: "calc(50% - 50vw)",
          width: "100vw",
          py: 1.25,
          px: { xs: 0.5, sm: 1, md: 2 },
        }}
      >
        <Box
          sx={{
            position: "relative",
            background: GLASS.bg,
            border: GLASS.border,
            boxShadow: GLASS.shadow,
            color: GLASS.text,
            borderRadius: 0,
            p: 1,
            overflow: "hidden",
            backdropFilter: "blur(8px)",

            
            "&:before, &:after": {
              content: '""',
              position: "absolute",
              top: 0,
              bottom: 0,
              width: "56px",
              zIndex: 2,
              pointerEvents: "none",
            },
            "&:before": {
              left: 0,
              background:
                "linear-gradient(90deg, rgba(10,13,17,0.95) 0%, rgba(10,13,17,0) 100%)",
            },
            "&:after": {
              right: 0,
              background:
                "linear-gradient(270deg, rgba(10,13,17,0.95) 0%, rgba(10,13,17,0) 100%)",
            },
          }}
        >
          {/* track with stories*/}
          <Box
            ref={trackRef}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseLeave={stopDrag}
            onMouseUp={stopDrag}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: { xs: 0.5, sm: 1 },
              py: 0.75,
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": { display: "none" },
              cursor: dragging ? "grabbing" : "grab",
            }}
          >
            {/* tick */}
            {promoTickets.map((t) => {
              const recently = isRecentlyStarted(t); 
              return (
                <Box key={t.id + "-" + tick} data-card sx={{ px: 0.75, scrollSnapAlign: "start" }}>
                  <PromoStoryRing
                    size={mdUp ? "sm" : "xs"}
                    avatar={t.avatar}
                    avatarScale={t.avatarScale}
                    title={t.title}
                    amount={t.amount}
                    token={t.token}
                    category={t.category}
                    due={t.due}
                    startAt={t.startAt}
                    boosted={t.boosted}
                    recentlyStarted={recently}
                    onClick={() => handleOpen(t)}
                  />
                </Box>
              );
            })}
          </Box>

          {/* arrows - only on desktop */}
          <IconButton
            onClick={() => scrollByCards(-1)}
            sx={{
              display: { xs: "none", md: "flex" },
              position: "absolute",
              left: 6,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
              border: GLASS.border,
              backdropFilter: "blur(6px)",
              background: "rgba(0,0,0,.35)",
              "&:hover": { background: "rgba(0,0,0,.5)" },
            }}
            size="small"
          >
            <ChevronLeftIcon htmlColor="#fff" />
          </IconButton>

          <IconButton
            onClick={() => scrollByCards(1)}
            sx={{
              display: { xs: "none", md: "flex" },
              position: "absolute",
              right: 6,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
              border: GLASS.border,
              backdropFilter: "blur(6px)",
              background: "rgba(0,0,0,.35)",
              "&:hover": { background: "rgba(0,0,0,.5)" },
            }}
            size="small"
          >
            <ChevronRightIcon htmlColor="#fff" />
          </IconButton>
        </Box>
      </Box>

      {/* Dialogue*/}
      <PromoQuestDialog
  open={open}
  onClose={handleClose}
  promo={selected}
  user={user}
   onStart={(quest) => {
      if (!quest) return;
     // Let's mark the start in LS (for "recently started")
     try {
       const key = `quest:${user?.uid}:${String(quest.id)}:startedAt`;
       localStorage.setItem(key, String(Date.now()));
     } catch {}

      if (quest.type === 'tg_join') {

       // A little more secure is via buildTelegramOpen 
       const { webUrl, deepLink } = buildTelegramOpen(quest.tg || {});
       smartOpen(webUrl, deepLink);
      } else if (quest.type === 'tg_comment_code') {
        smartOpen(quest.tg?.universalUrl, quest.tg?.deepLink);
      } else if (quest.type === 'x_follow') {
        smartOpen(quest.x?.profileUrl, quest.x?.profileUrl);
      } else if (quest.type === 'x_retweet') {
        smartOpen(quest.x?.tweetUrl, quest.x?.tweetUrl);
      } else if (quest.type === 'x_post_code') {

      
       smartOpen('https://x.com/compose/post', 'https://x.com/compose/post');
      }
    }}
  />

    </>
  );
};

export default PromoTickets;
